module.exports = __webpack_public_path__ + "img/nis.33b3dbbc.svg";